<template>
  <!-- Mais larga que as outras janelas (960px): as duas colunas do editor, com a fórmula legível.
       Fecha só pelo X, como as janelas de formulário (`FormDialog`). O painel direto dentro do diálogo,
       sem div em volta: o cinza do salvar se posiciona contra o ancestral mais próximo (ver o `FormPanel`) -->
  <ontos-dialog :model-value="true" :fullscreen="$vuetify.display.smAndDown" max-width="1120px" persistent>
    <ontos-property-editor :idea="idea" :workspace="workspace" :property="property" :identifier="identifier"
                           :saving="saving" @save="$emit('save', $event)">
      <!-- O Expandir não pergunta nada: o rascunho vai junto, e não há o que perder (pedido do usuário) -->
      <template #controls="{dirty, resume}">
        <ontos-dialog-actions :on-full-page="() => expand(resume)" :dirty="dirty" :disabled="saving"
                              @closed="$emit('closed')"/>
      </template>
    </ontos-property-editor>
  </ontos-dialog>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import Idea from '@/types/Idea'
import IdeaProperty from '@/types/IdeaProperty'
import {EnhancedWorkpace} from '@/types/Workspace'
import {handOver} from '@/utils/handover'
import PropertyEditor, {PropertyResume} from '@/components/design/property/PropertyEditor.vue'
import {propertyKey, propertyRoute} from '@/utils/propertyLink'

/**
 * Criar e editar propriedade numa janela: o editor (`PropertyEditor`) com o X e o Expandir.
 *
 * Expandir leva à página da propriedade o que se preencheu (`PropertyResume`), sem ir ao servidor —
 * como o Expandir da edição de item (pedido do usuário). A página compara com o mesmo original, e o
 * Salvar e o aviso de saída seguem valendo do mesmo jeito.
 */
@Component({emits: ['closed', 'save'],
  name: 'ontos-property-dialog',
  components: {'ontos-property-editor': PropertyEditor}
})
class PropertyDialog extends Vue {
  @Prop({type: Object, required: true}) readonly idea!: Idea
  @Prop({required: true}) readonly workspace!: EnhancedWorkpace
  /** undefined = criando; objeto = editando aquela propriedade */
  @Prop({default: undefined}) readonly property!: IdeaProperty | undefined
  /** o host controla: ele é quem persiste */
  @Prop({type: Boolean, default: false}) readonly saving!: boolean
  /** Criar já no identificador — ver o `PropertyEditor`. */
  @Prop({type: Boolean, default: false}) readonly identifier!: boolean

  /** A página da propriedade, com o que está na janela entregue a ela. */
  expand(resume: () => PropertyResume) {
    const alias = this.property && this.property.alias
    handOver(propertyKey(this.workspace.alias, this.idea.alias, alias), {resume: resume(), identifier: this.identifier})
    this.$router.push(propertyRoute(this.workspace.alias, this.idea.alias, alias)).catch(() => undefined)
  }
}

export default toNative(PropertyDialog)
</script>
